import linkifyHtml from "linkify-html"

// `<` that doesn't open a real tag (`<12>`, `<9/28/2026>`) is plain text: escape it so it isn't parsed as markup
const escapeStrayLessThan = (html: string) => html.replace(/<(?!\/?[a-z][a-z0-9]*(\s[^<>]*)?\/?>)/gi, "&lt;")

// linkify-html throws on malformed markup, which would crash the whole chat
export const safeLinkifyHtml = (html: string) => {
    const escaped = escapeStrayLessThan(html)
    try {
        return linkifyHtml(escaped)
    } catch {
        return escaped
    }
}
